var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height"
    },
    [
      _c(
        "v-skeleton-loader",
        {
          attrs: {
            loading: _vm.loading,
            type: "article"
          }
        },
        [
          _c("gg-card-header", [_vm._v(" Affiliate Information ")]),
          _vm.profile
            ? _c(
                "gg-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm._v(" Affiliate Username: "),
                              _c(
                                "b",
                                {
                                  ref: "username"
                                },
                                [_vm._v(_vm._s(_vm.profile.username))]
                              ),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: ""
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.copyToClipboard("username")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-content-copy")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _vm._v(" Your Affiliate Tracking URL: "),
                              _c(
                                "b",
                                {
                                  ref: "url"
                                },
                                [
                                  _vm._v(
                                    "https://www.greengeeks.com/track/" +
                                      _vm._s(_vm.profile.username)
                                  )
                                ]
                              ),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: ""
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.copyToClipboard("url")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-content-copy")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }